import React from 'react';
const painPoints = ['El lunes a las 8:50 todavía no sabés qué vas a trabajar en la sesión de las 9. Y eso se nota en el encuadre.', 'Tus pacientes llevan meses en tratamiento pero no podés mostrar una progresión clínica clara ni articular el proceso en una supervisión.', 'Un paciente te pregunta "¿hacia dónde vamos?" y lo único que podés dar es una respuesta vaga. Sin plan, sin objetivos, sin respaldo clínico.', 'El domingo a las 23:00 seguís revisando apuntes de la facultad buscando intervenciones que no tienen secuencia terapéutica real para ese caso.', 'Sabés que deberías cobrar más, pero no tenés un sistema profesional visible que justifique ese honorario frente al paciente y frente a vos mismo.', 'Cada sesión empieza desde cero. Sin progresión, sin objetivo medible, sin fundamento clínico. Y lo peor: ya te acostumbraste a esa sensación.'];
export function PainPoints() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(254,242,242) 0%, rgb(254,242,242) 15%, rgb(254,242,242) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-188">
      <div className="mx-auto max-w-3xl" data-id="element-189">
        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-190">
          ¿Te sentís identificado/a?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-191">
          Esto le pasa al 90% de los psicólogos
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-192">
          No es falta de formación. Es falta de un sistema.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-193">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-194">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-195">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-196">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-violet-700 m-0 mb-6" data-id="element-197">
          ¿Cuántas sesiones más vas a improvisar?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgb(124, 58, 237), rgba(255, 255, 255, 0))'
      }} data-id="element-198" />
      </div>
    </section>;
}